import React from 'react';

import { useTheme } from 'utils/theme';

import { SVGComponentProps } from './SVG.props';

const Logo = (props: SVGComponentProps): JSX.Element => {
  const theme = useTheme();
  const { width, height, color, accent } = props;

  return (
    <svg
      width={width || '15.285'}
      height={height || '15.285'}
      viewBox="0 0 15.285 15.285"
    >
      <defs>
        <style>{`.cls-3{fill:${theme.colors[color || 'primary']}}`}</style>
      </defs>
      <g transform="scale(.06543)">
        <g>
          <path
            d="M223.76 37.88c2.16-3.85 3.69-8.03 4.51-12.37 1.71-9.18-.21-17.75-5.58-24.79-.35-.45-.89-.73-1.47-.72-.58 0-1.12.27-1.47.72a29.623 29.623 0 0 0-5.6 12.31c-.02.06-.03.12-.04.18h3.76v-.01c.63-2.89 1.77-5.66 3.35-8.17 3.64 5.81 4.8 12.47 3.42 19.83-.66 3.48-1.81 6.86-3.43 10.01-2.08-4.07-3.38-8.5-3.85-13.05a43.33 43.33 0 0 1-3.5 1.82c.68 4.96 2.29 9.75 4.73 14.13-2.52 1.69-5.43 5.14-5.43 10a25.874 25.874 0 0 1 16.09 0c0-5.07-3.32-8.3-5.51-9.88z"
            className="cls-3"
          />
          <path
            d="M222.45 16.58c-.15-.61-.65-1.13-1.45-1.13h-45.55c-4.64-11.77-14.31-14.17-25.26-14.17-7.51 0-15.63 1.14-23.12 1.14-3.08 0-6.05-.2-8.84-.74a2.34 2.34 0 0 0-.38-.03c-1.57 0-2.5 1.92-1.36 3.16 1.16 1.26 2.55 2.57 4.11 3.62-4.4 2.7-11.02 7.78-14.63 16.29-.57 1.34-1.01 2.65-1.36 3.92-.1.36-.17.93-.23 1.63-.23 3.19-.03 8.95-.03 8.95a4.228 4.228 0 0 1-4.13 3.27c-1.7 0-3.22-1.03-3.91-2.59-1.24-2.81-4.24-6.9-11.13-6.9l-77.99-.96-1.25-.02A6.482 6.482 0 0 0 0 38.48c0 .51.06 1 .16 1.47.16.46.33.92.52 1.41 6.98 18.67 30.74 58.5 102.81 58.5v105.9c.01.45.37.8.8.8h.02a.83.83 0 0 0 .74-.51L132.24 135c.18-.47.48-.89.88-1.2l9.01-7.12a70.533 70.533 0 0 0 26.66-48.05c.04-.27.06-.55.09-.82.21-2.24.32-4.48.32-6.74l-.02-37.94c15.91-4.02 50.95-13.03 52.6-14.9.12-.14.22-.27.3-.4.5-.75.37-1.25.37-1.25zm-59.05-4.97a3.74 3.74 0 1 1-.001 7.481 3.74 3.74 0 0 1 .001-7.481zm1.7 66a67.024 67.024 0 0 1-6.41 22.74 67.18 67.18 0 0 1-18.9 23.37l-8.99 7.11c-.95.74-1.67 1.72-2.09 2.82l-21.44 56.04v-14.22c14.53-42.95 13.78-56.12 13.74-56.63V81.22c-.01-.11-1.68-11.53-10.75-11.53-20.64 0-35.79-4.79-45.03-14.25-7.52-7.68-8.72-16.25-8.9-19.03l28.8.36h.05c3.73 0 6.31 1.57 7.69 4.65 1.29 2.95 4.18 4.84 7.35 4.84.05 0 .11 0 .17-.01l35.42.01c16.43 0 29.29 12.6 29.29 28.68zm.31-47.42v30.09c-5.35-10.64-16.47-17.79-29.6-17.79h-28.78c.46-.73.79-1.54 1-2.42l.1-.48v-.5c-.15-3.9-.09-7.93.08-9.22l97.72-10.33c-8.24 2.33-40.52 10.65-40.52 10.65z"
            className="cls-3"
          />
          <path
            d="M165.41 30.19v30.09c-5.35-10.64-16.47-17.79-29.6-17.79h-28.78c.46-.73.79-1.54 1-2.42l.1-.48v-.5c-.15-3.9-.09-7.93.08-9.22l97.72-10.33c-8.24 2.33-40.52 10.65-40.52 10.65z"
            style={{
              fill: '#eaeefe',
            }}
          />
          <path
            d="M165.1 74.94v2.67a67.024 67.024 0 0 1-6.41 22.74 67.18 67.18 0 0 1-18.9 23.37l-8.99 7.11c-.95.74-1.67 1.72-2.09 2.82l-21.44 56.04v-14.22c14.53-42.95 13.78-56.12 13.74-56.63V81.22c-.01-.11-1.68-11.53-10.75-11.53-20.64 0-35.79-4.79-45.03-14.25-7.52-7.68-8.72-16.25-8.9-19.03l28.8.36h.05c3.73 0 6.31 1.57 7.69 4.65 1.29 2.95 4.18 4.84 7.35 4.84.05 0 .11 0 .17-.01l35.42.01c16.43 0 29.29 12.6 29.29 28.68z"
            style={{
              fill: accent ? theme.colors[accent] : '#45faa7',
            }}
          />
        </g>
      </g>
    </svg>
  );
};

export default Logo;
